/**
 * Os atalhos de periodo da lista de Colaboradores.
 *
 * O periodo aqui pergunta "quem REGISTROU algo entre estas datas" - a mesma definicao de
 * ativo dos indicadores de Adocao e Engajamento, e e por isso que os cartoes de la abrem
 * esta tela preenchendo justamente este filtro.
 *
 * `all` vem primeiro e e o estado inicial: a lista sempre mostrou todo mundo, e abrir com
 * um recorte de data mudaria calado o que ela lista.
 *
 * Os atalhos sao os mesmos dos Monitoramentos, e sao uma lista propria mesmo assim: o dono
 * do vocabulario e quem publica o parametro, e `activeFrom`/`activeTo` sao de
 * `CollaboratorsKeys`. Compartilhar a lista faria as duas telas mudarem juntas por
 * acidente no dia em que uma delas ganhasse um atalho.
 *
 * As janelas de 7, 15 e 30 dias existem porque sao as do seletor "ATIVO EM" daquela outra
 * tela - quem clica num cartao de "Ativos (15 dias)" precisa reconhecer o recorte aqui.
 *
 * E por isso que aqui e `15d` e nao `14d`, que e o vizinho que as outras telas oferecem:
 * quinze dias e uma das tres janelas de "Ativo em", quatorze nao e nenhuma. Enquanto
 * foi `14d`, a promessa do paragrafo acima estava escrita e nao cumprida - o cartao de
 * quinze dias abria esta lista com um intervalo que nenhum atalho daqui reconhecia, e o
 * seletor so sabia chama-lo de "Escolher datas".
 */
export const COLLABORATOR_SHORTCUTS = ['all', '7d', '15d', '30d', '90d', 'custom'];
//# sourceMappingURL=collaborators.periods.js.map